/**
 * Calculate percent
 * Return 'N/A' if incorrect or not available data
 * @param  {number} numerator
 * @param  {number} denominator
 * @returns string
 */
export function calculatePercent(numerator: number, denominator: number): string {
  if (denominator !== 0) {
    const result = Math.round((numerator/denominator) * 100);
    if (result) return result + '%';
  }
  return 'N/A';
}
